import authApi from 'api/authApi';
import feApi from 'api/feApi';
import { updateAxiosAccessToken } from 'api/axiosClient';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';
import RoleUtils from 'general/utils/RoleUtils';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// dang nhap admin/agency
export const thunkLogIn = createAsyncThunk('auth/thunkLogIn', async (params, thunkAPI) => {
  let adminRes = null;
  let adminError = null;

  try {
    adminRes = await authApi.signIn(params);
    if (RoleUtils.isAdminUiRole(adminRes?.user?.role)) return adminRes;
  } catch (error) {
    adminError = error;
  }

  try {
    const customerRes = await feApi.signIn(params);
    return customerRes;
  } catch (customerError) {
    if (adminRes?.result === 'success') return adminRes;

    const adminErrorData = adminError?.response?.data;
    const customerErrorData = customerError?.response?.data;
    const preferredErrorData =
      adminError?.response?.status && adminError.response.status !== 404
        ? adminErrorData
        : customerErrorData ?? adminErrorData;

    return {
      result: 'failed',
      reason:
        preferredErrorData?.reason ??
        'Đăng nhập không thành công',
    };
  }
});

// ---- params ----
const initialState = {
  isLoggingIn: false,
  user: {},
  agencyRoleList: [],
  permissionList: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthSlice: (state, action) => {
      return initialState;
    },
    updateUser: (state, action) => {
      state.user = action.payload ?? {};
    },
    setAgencyRoleList: (state, action) => {
      state.agencyRoleList = action.payload ?? '';
    },
    setPermissionList: (state, action) => {
      state.permissionList = action.payload ?? '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunkLogIn.pending, (state, action) => {
        state.isLoggingIn = true;
      })
      .addCase(thunkLogIn.rejected, (state, action) => {
        state.isLoggingIn = false;
      })
      .addCase(thunkLogIn.fulfilled, (state, action) => {
        state.isLoggingIn = false;
        const { result, user, reason } = action.payload;
        if (result == 'success') {
          let token = user?.token;
          const isAdminUi = RoleUtils.isAdminUiRole(user?.role);
          localStorage.setItem(PreferenceKeys.accessToken, token);
          localStorage.setItem(PreferenceKeys.savedLoginEmail, user?.email);
          localStorage.setItem(PreferenceKeys.savedActiveRole, `${user?.role || ''}`.trim().toUpperCase());
          localStorage.setItem(
            PreferenceKeys.savedUiMode,
            isAdminUi ? RoleUtils.uiModes.cms : RoleUtils.uiModes.customer
          );
          updateAxiosAccessToken(token);
          state.user = user ?? {};
          state.agencyRoleList = RoleUtils.getAgencyRoles(user);

          const permissionList = user?.permissionGroup?.permissions?.map((permission) => {
            return { path: permission.fe_path, code: permission.code };
          });
          state.permissionList = permissionList;
        } else {
          ToastHelper.showError(reason);
        }
      });
  },
});

const { reducer, actions } = authSlice;
export const { resetAuthSlice, updateUser, setAgencyRoleList, setPermissionList } = actions;
export default reducer;
